<template>
  <div class="signin_button_alert">
    <p>手机号登录</p>
    <ul>
      <li>
        <input type="tel" v-model="mobile" placeholder="请输入手机号" />
        <img class="del-btn" src="/static/wx/img/close3.png" v-if="mobile" @click="mobile = ''" />
      </li>
      <li>
        <input type="text" v-model="code" placeholder="图片验证码" />
        <img class="del-btn" src="/static/wx/img/close3.png" v-if="code" @click="code = ''" />
        <img ref="codeImg" :src="codeImg" alt="" @click="getCodeImg" />
      </li>
      <li>
        <input type="tel" v-model="sms" placeholder="验证码" />
        <img class="del-btn" src="/static/wx/img/close3.png" v-if="sms" @click="sms = ''" />
        <i class="countdown" v-if="time == 60" @click="sendAgain">获取验证码</i>
        <i class="countdown" v-else-if="time != 0">{{ time }}s后重新发送</i>
        <i class="countdown sendAgain" v-else-if="time == 0" @click="sendAgain">重新发送</i>
      </li>
    </ul>
    <van-button
      type="primary"
      block
      color="linear-gradient(to right, #FB6E38, #FE9B4B)"
      @click="confirm"
    >
      登录
    </van-button>
  </div>
</template>

<script>
import { random_string, basepath, isWeixin, fenxiang } from '../../assets/common/js/config'
export default {
  name: 'meetingloginin',
  data() {
    return {
      ismobile: 0,
      mobile: '',
      code: '',
      sms: '',
      codeImg: null, // 图片验证码
      timeout: null, // 事件随机码
      imgCodeValue: '', // 图片验证码-值
      time: 60
    }
  },
  mounted() {
    if (isWeixin()) {
      fenxiang({ path: 'meetingloginin' })
    }
    this.getCodeImg()
  },
  methods: {
    // 获取图形验证码
    getCodeImg() {
      let width = this.$refs.codeImg.clientWidth
      let height = this.$refs.codeImg.clientHeight
      this.code = ''
      this.timeout = new Date().getTime() + '' + random_string(16)

      this.codeImg = this.$ajax.getValidateCode_URL(
        'sessionid=' + this.timeout + '&width=' + width + '&height=' + height
      )
    },
    Code() {
      let that,
        area_code = 86,
        url
      that = this
      url =
        this.$ajax.getValidCode_URL +
        '?newVersion=1&mobile=' +
        this.mobile +
        '&code=' +
        that.code +
        '&sessionid=' +
        this.timeout +
        '&type=3&area_code=' +
        area_code
      this.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          that.time = 60
          that.countdown()
        } else if (res.data.code == '10011') {
          this.$toast(res.data.msg)
          that.getCodeImg()
        }
      })
    },
    countdown: function() {
      var that = this
      var timer = setInterval(function() {
        that.time--
        if (that.time <= 0) {
          that.time = 0
          // if (!that.imgCodeWrapFlag) {
          //   that.imgCodeWrapFlag = true
          // }
          clearInterval(timer)
        }
      }, 1000)
    },
    sendAgain: function() {
      if (this.check('sms')) this.Code()
    },
    check: function(type) {
      if (!this.mobile) {
        this.$toast('请先输入手机号')
        return false
      } else if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        this.$toast('请输入正确的手机号')
        return false
      } else if (!this.code) {
        this.$toast('请输入图片验证码')
        return false
      } else if (!this.sms) {
        if (type == 'sms') {
          return true
        } else {
          this.$toast('请先输入短信验证码')
          return false
        }
      } else {
        return true
      }
    },
    confirm: function() {
      if (this.check()) {
        var url = this.$ajax.smsCodeVerify_URL + '?mobile=' + this.mobile + '&code=' + this.sms
        this.$customRequestAjax(url).then((res) => {
          if (res.data.code == 200) {
            this.signinFn()
          } else {
            this.$toast('验证码有误')
            this.sms = ''
          }
        })
      }
    },
    signinFn() {
      var url = this.$ajax.mobileLogin_URL,
        data = {
          mobile: this.mobile,
          code: this.sms,
          area_code: 86
        }
      this.$customRequestAjax.post(url, data).then((res) => {
        if (res.data.code == 200) {
          sessionStorage.setItem('meetinglogin_mobile', this.mobile)
          this.$router.push('/meetinglist')
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/common/css/createmeeting';
.signin_button_alert {
  height: calc(100vh);
  background: #ffffff;
  padding: 0 0.19rem;
  p {
    color: #444444;
    font-size: 0.24rem;
    margin: 0.2rem 0 0;
  }
  ul {
    margin: 0.4rem 0 0.64rem;
    li {
      height: 0.4rem;
      width: 100%;
      background: #f6f7fa;
      margin-top: 0.16rem;
      padding: 0 0.07rem 0 0.1rem !important;
      border: none !important;
      border-radius: 0.02rem;
      display: flex;
      align-items: center;
      -webkit-align-items: center;

      .del-btn {
        width: 0.13rem;
        height: 0.13rem;
        border: none;
      }

      img {
        width: 0.85rem;
        flex-shrink: 0;
        -webkit-flex-shrink: 0;
        height: 0.32rem;
        margin-left: 0.07rem;
        border: 0.01rem solid #5d6bfb;
        border-radius: 0.02rem;
      }

      i {
        font-size: 0.13rem;
        color: #5d6bfb;
        font-style: normal;
        flex-shrink: 0;
        -webkit-flex-shrink: 0;
        margin-left: 0.07rem;
      }

      &:first-of-type {
        margin-top: 0;
      }

      input {
        height: 100%;
        width: 100%;
        font: initial;
        padding: 0 !important;
        border: none;
        outline: none;
        background: #f6f7fa;
        color: #333333;

        &::placeholder {
          color: #999999;
          font-size: 0.13rem;
        }
      }
    }
  }
  .van-button--primary {
    border-radius: 0.08rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/createmeeting/meetingloginin.vue